import PageTitle from "@components/Common/PageTitle";
import HeaderComponent from "@components/VerticalLayout/HeaderComponent";
import { CardBody, Container } from "reactstrap";

import React from "react";
import { useTranslation } from "react-i18next";
import BreadcrumbOptions from "./BreadcrumbOptions";

function AdyenPaiementsOverview() {
    const holderAccountId = localStorage.getItem("holderAccountId");
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <PageTitle title="Paiement SoftaveraPay" />
            <div className="">
                <BreadcrumbOptions
                    currentLink={[
                        {
                            item: t("SOFTAVERAPAY"),
                            link: `${process.env.REACT_APP_PORTAIL_API}`,
                        },
                        {
                            item: t(`${"Rapports"}`),
                            link: `${"Transactions"}`,
                        },
                        {
                            item: t(`${"Versement"}`),
                            link: `${"Paiements"}`,
                        },
                    ]}
                />

                <Container fluid>
                    <HeaderComponent
                        title={t(
                            `The 'Payouts' report shows the automatic payouts for a balance account over a given period, including details such as the date, captured funds, adjustments, and net payout. After adjustments (fees, commissions, etc.), the final amount is credited to the user's bank account.`
                        )}
                    />

                    <CardBody
                        style={{
                            padding: "1px",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                marginTop: "10px",
                                height: "618px",
                            }}
                        >
                            <div style={{ width: "100%", height: "100%" }}>
                                {" "}
                                <iframe
                                    src={`${process.env.REACT_APP_SOFTAVERAPAY}?accountHolder=${holderAccountId}&role=paiements`}
                                    //    src={`http://192.168.2.63:8082?accountHolder=${holderAccountId}&role=paiements`}
                                    width="100%"
                                    height="100%"
                                    title="Embedded URL"
                                />
                            </div>
                        </div>
                    </CardBody>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default AdyenPaiementsOverview;
